import React from "react";
import "./competions.css";
const Competitions = () => {
    return (
        <>
            <header>
                <nav>
                    <h2>Mood Indigo</h2>
                </nav>
            </header>
            <main>
                <section className="hero">
                    <h1>Welcome to Competitions at Mood Indigo</h1>
                    <p>
                        Your ultimate destination for music and entertainment!
                    </p>
                    <a href="/admin/multicity" className="btn btn-primary mx-3">
                        Admin Page
                    </a>
                    <a href="/judge/multicity" className="btn btn-primary mx-3">
                        Judge Page
                    </a>
                </section>
            </main>
            <div className="remaning">
                <section className="about">
                    <h2>About Us</h2>
                    <p>
                        At Mood Indigo, we are passionate about bringing people
                        together through the power of music and art. We believe
                        that music has the unique ability to connect
                        individuals, transcend boundaries, and create
                        unforgettable experiences. That's why we've dedicated
                        ourselves to curating and hosting the most electrifying
                        events and experiences in the world of entertainment.
                    </p>
                </section>
            </div>
        </>
    );
};

export default Competitions;
